/** Lives with the theme because these are `defaultProps` — see `checkbox.ts` for the root/box split. */

import Icons from "assets";

/** The box the theme sizes and paints every state on. */
export const CHECKBOX_BOX_CLASS = "ApolloCheckbox-box";

/**
 * The mark inside the box. A class rather than a bare `& svg` descendant for two reasons:
 * `specificity()` in `src/__tests__/css-cascade.ts` counts dots, so a type selector would make the helper's
 * cascade model wrong rather than merely coarse; and it scopes the rule to *our* mark rather than to any SVG
 * that ends up inside a checkbox.
 *
 * Setting the mark's colour here also frees the root's `color` to do its MUI job — tinting the ripple — instead
 * of bleeding into the glyph through `currentColor`.
 */
export const CHECKBOX_GLYPH_CLASS = "ApolloCheckbox-glyph";

/**
 * Per-mark modifiers, carrying no styles. They exist because Jest maps every `.svg` to one mock that renders
 * a featureless `<svg>`, so a test has no other way to tell the tick from the bar. Prefixed
 * `ApolloCheckbox-` rather than `MuiCheckbox-` so `generateUtilityClass` can never mint the same name and
 * start matching them.
 */
export const CHECKBOX_CHECK_GLYPH_CLASS = "ApolloCheckbox-glyphCheck";
export const CHECKBOX_MINUS_GLYPH_CLASS = "ApolloCheckbox-glyphMinus";

const CheckboxBlankBox = () => <span className={CHECKBOX_BOX_CLASS} />;

const CheckboxCheckBox = () => (
  <span className={CHECKBOX_BOX_CLASS}>
    <Icons.Checkmark
      className={`${CHECKBOX_GLYPH_CLASS} ${CHECKBOX_CHECK_GLYPH_CLASS}`}
      aria-hidden
    />
  </span>
);

const CheckboxMinusBox = () => (
  <span className={CHECKBOX_BOX_CLASS}>
    <Icons.Minus className={`${CHECKBOX_GLYPH_CLASS} ${CHECKBOX_MINUS_GLYPH_CLASS}`} aria-hidden />
  </span>
);

export const CHECKBOX_BLANK_BOX = <CheckboxBlankBox />;
export const CHECKBOX_CHECK_BOX = <CheckboxCheckBox />;
export const CHECKBOX_MINUS_BOX = <CheckboxMinusBox />;
